function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2
}, /*#__PURE__*/React.createElement("rect", {
  opacity: 0.01,
  width: 20,
  height: 20,
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.66669 10C1.66669 5.39765 5.39765 1.66669 10 1.66669C12.2102 1.66669 14.3298 2.54466 15.8926 4.10746C17.4554 5.67027 18.3334 7.78988 18.3334 10C18.3334 14.6024 14.6024 18.3334 10 18.3334C5.39765 18.3334 1.66669 14.6024 1.66669 10ZM3.33335 10C3.33335 13.6819 6.31812 16.6667 10 16.6667C11.7681 16.6667 13.4638 15.9643 14.7141 14.7141C15.9643 13.4638 16.6667 11.7681 16.6667 10C16.6667 6.31812 13.6819 3.33335 10 3.33335C6.31812 3.33335 3.33335 6.31812 3.33335 10Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.5 9.16669H10.8334V7.50002C10.8334 7.03978 10.4603 6.66669 10 6.66669C9.53978 6.66669 9.16669 7.03978 9.16669 7.50002V9.16669H7.50002C7.03978 9.16669 6.66669 9.53978 6.66669 10C6.66669 10.4603 7.03978 10.8334 7.50002 10.8334H9.16669V12.5C9.16669 12.9603 9.53978 13.3334 10 13.3334C10.4603 13.3334 10.8334 12.9603 10.8334 12.5V10.8334H12.5C12.9603 10.8334 13.3334 10.4603 13.3334 10C13.3334 9.53978 12.9603 9.16669 12.5 9.16669Z",
  fill: "black"
}));

function SvgIconPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlus);
export default __webpack_public_path__ + "static/media/icon-plus.2c2a4982.svg";
export { ForwardRef as ReactComponent };